/* ==========================================================================
   BRASSLUXE MOROCCO — generative zellige canvas (ES module)
   Paints an 8-pointed-star (khatam) zellige tiling on [data-zellige-canvas]
   inside .newsletter-moroccan. Colors drift between Fès blue and zellige
   emerald with brass linework; the pattern slowly drifts and breathes.

   Honors the shared runtime:
     BrassLuxe.reducedMotion / particleScale 0 → paint once, static
     BrassLuxe.particleScale → pattern density/detail
     IntersectionObserver → RAF only runs while on screen
     BrassLuxe.mount cleanup → cancel RAF, disconnect observers
   ========================================================================== */
(function () {
  'use strict';

  var BLX = window.BrassLuxe;
  if (!BLX || typeof BLX.mount !== 'function') return;

  var TAU = Math.PI * 2;

  function hexToRgb(hex, fallback) {
    var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return fallback;
    var n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function mix(a, b, t) {
    return [
      Math.round(a[0] + (b[0] - a[0]) * t),
      Math.round(a[1] + (b[1] - a[1]) * t),
      Math.round(a[2] + (b[2] - a[2]) * t)
    ];
  }

  function rgba(c, alpha) {
    return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + alpha + ')';
  }

  /* deterministic per-tile hash for static color variation */
  function tileHash(ix, iy) {
    var s = Math.sin(ix * 127.1 + iy * 311.7) * 43758.5453;
    return s - Math.floor(s);
  }

  /* 8-pointed star (two overlapping squares): outer tips at 8 angles,
     inner vertices at R / sqrt(2) — the classic khatam silhouette. */
  function starPath(ctx, x, y, r, rot) {
    var inner = r / Math.SQRT2;
    ctx.beginPath();
    for (var i = 0; i < 16; i++) {
      var rad = i % 2 === 0 ? r : inner;
      var ang = rot + (i * Math.PI) / 8;
      var px = x + Math.cos(ang) * rad;
      var py = y + Math.sin(ang) * rad;
      if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
    }
    ctx.closePath();
  }

  BLX.mount('.newsletter-moroccan', function (el) {
    var canvas = el.querySelector('[data-zellige-canvas]');
    if (!canvas || !canvas.getContext) return undefined;

    var ctx = canvas.getContext('2d');
    var colorA = hexToRgb(canvas.getAttribute('data-color-a'), [27, 58, 92]);   /* Fès blue */
    var colorB = hexToRgb(canvas.getAttribute('data-color-b'), [14, 110, 92]);  /* zellige emerald */
    var line = hexToRgb(canvas.getAttribute('data-line'), [201, 162, 39]);      /* brass */

    var staticOnly = BLX.reducedMotion || BLX.particleScale <= 0;
    var scale = Math.max(BLX.particleScale, 0.15);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0;
    var height = 0;
    var raf = null;
    var visible = false;

    /* tile size: denser pattern when particle density is high */
    function tileSize() {
      return Math.round(170 - 80 * scale);
    }

    function resize() {
      var rect = canvas.getBoundingClientRect();
      width = Math.max(1, Math.round(rect.width));
      height = Math.max(1, Math.round(rect.height));
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (staticOnly) paint(0);
    }

    function paint(time) {
      ctx.clearRect(0, 0, width, height);

      var s = tileSize();
      var r = s * 0.42;
      var driftX = staticOnly ? 0 : (time * 0.006) % s;
      var driftY = staticOnly ? 0 : (time * 0.004) % s;
      var breath = staticOnly ? 0 : Math.sin(time * 0.00012) * 0.035;

      ctx.save();
      ctx.translate(width / 2, height / 2);
      ctx.rotate(breath);
      ctx.translate(-width / 2, -height / 2);

      var cols = Math.ceil(width / s) + 3;
      var rows = Math.ceil(height / s) + 3;

      for (var iy = -2; iy < rows; iy++) {
        for (var ix = -2; ix < cols; ix++) {
          var cx = ix * s + s / 2 + driftX;
          var cy = iy * s + s / 2 + driftY;
          var h = tileHash(ix, iy);

          /* slow color wave between Fès blue and emerald */
          var wave = staticOnly
            ? h
            : 0.5 + 0.5 * Math.sin(time * 0.00035 + (ix + iy) * 0.55 + h * TAU);
          var fill = mix(colorA, colorB, wave);

          starPath(ctx, cx, cy, r, Math.PI / 8);
          ctx.fillStyle = rgba(fill, 0.14 + 0.22 * h);
          ctx.fill();
          ctx.strokeStyle = rgba(line, 0.35 + 0.25 * h);
          ctx.lineWidth = 1;
          ctx.stroke();

          /* small cross-square in the gap between four stars */
          if (scale > 0.25) {
            var gx = cx + s / 2;
            var gy = cy + s / 2;
            var g = s * 0.09;
            ctx.beginPath();
            ctx.moveTo(gx, gy - g);
            ctx.lineTo(gx + g, gy);
            ctx.lineTo(gx, gy + g);
            ctx.lineTo(gx - g, gy);
            ctx.closePath();
            ctx.fillStyle = rgba(mix(colorA, colorB, 1 - wave), 0.3);
            ctx.fill();
            ctx.strokeStyle = rgba(line, 0.4);
            ctx.stroke();
          }

          /* inner detail dot on denser settings */
          if (scale > 0.55) {
            ctx.beginPath();
            ctx.arc(cx, cy, s * 0.045, 0, TAU);
            ctx.strokeStyle = rgba(line, 0.5);
            ctx.stroke();
          }
        }
      }
      ctx.restore();
    }

    function loop(time) {
      raf = null;
      paint(time);
      if (visible && !staticOnly) raf = requestAnimationFrame(loop);
    }

    function start() {
      if (staticOnly || raf !== null || !visible) return;
      raf = requestAnimationFrame(loop);
    }

    function stop() {
      if (raf !== null) {
        cancelAnimationFrame(raf);
        raf = null;
      }
    }

    resize();

    var io = null;
    if ('IntersectionObserver' in window && !staticOnly) {
      io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { rootMargin: '120px 0px' });
      io.observe(el);
    } else {
      visible = true;
      start();
    }

    var ro = null;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(function () {
        resize();
        if (staticOnly) paint(0);
      });
      ro.observe(el);
    } else {
      window.addEventListener('resize', resize);
    }

    return function cleanup() {
      stop();
      if (io) io.disconnect();
      if (ro) ro.disconnect();
      else window.removeEventListener('resize', resize);
    };
  });
})();
